import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { lazy, useState } from "react";
import { Button, Image, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import "react-toggle/style.css";
import { changeLanguage } from "../../actions/store";
import config from "../../config";
import { languages } from "../../constants/language";
import { useMenu } from "../../menu-items";

const Sidebar: React.FC = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const imageUrl = `${config.awsUrl}${config.region}/Landing/`;
	const menu = useMenu();
	const currentLanguage = localStorage.getItem("Language") || "en";
	const [showLanguageModal, setShowLanguageModal] = useState(false);
	const [currentLink, setCurrentLink] = useState<string>("Home")
	const LogoComponent = lazy(() => import(`../common/logo`));

	const handleLanguageSelect = (lang: string) => {
		dispatch(changeLanguage(lang));
		localStorage.setItem("Language", lang);
		setShowLanguageModal(false);
	};

	return (
		<div id="sidebar" className="sidebar">
			<div className="sidebar-top">
				<LogoComponent />
				<hr className="hr-line" />
				<div className="lobbyTopContainer">
					<div className="lobbyTopItem">
						<img src="/icons/player.png" alt="Playericon" className="iconPlayer" />
						<span style={{ fontWeight: '500' }}>
							{t("Player")}
						</span>
					</div>
					<div className="lobbyTopDivider" />
					<a href={config.adminURL} className="lobbyTopItem">
						<img src="/icons/member.png" alt="Membericon" className="iconMember" />
						<span style={{ color: '#898989' }}>
							{t("Member")}
						</span>
					</a>
				</div>
			</div>
			<div id="sidemenu">
				{menu.map((item, index) => {
					if (!item.access) {
						return null;
					}

					if (item.type === "link" && typeof item.value === "string") {
						return (
							<div key={index} onClick={() => setCurrentLink(item.label)} className={currentLink === item.label ? "active-SideBarTab" : ""}>
								<Link to={item.value}>
									{/* <FontAwesomeIcon icon={item.icon} className="me-3" /> */}
									<Image
										src={imageUrl + "icons/" + item.id + ".png"}
										alt={item.id}
									/>
									{t(item.label)}
								</Link>
							</div>
						);
					} else if (
						item.type === "action" &&
						typeof item.value === "function"
					) {
						return (
							<div key={index} onClick={item.value} className="menu-div">
								{/* <FontAwesomeIcon icon={item.icon} className="me-3" /> */}
								<Image
									src={imageUrl + "icons/" + item.id + ".png"}
									alt={item.id}
								/>
								{t(item.label)}
							</div>
						);
					} else if (item.type === "dropdown") {
						return (
							<div key={index} className="menu-div" onClick={() => setShowLanguageModal(true)}>
								<Image
									src={imageUrl + "icons/" + item.id + ".png"}
									alt={item.id}
								/>
								{t(item.label)}
							</div>
						);
					}

					return null;
				})}
			</div>

			<Modal show={showLanguageModal} onHide={() => setShowLanguageModal(false)} className="modal-language" centered>
				<Modal.Header style={{ borderBottom: 'none', justifyContent: 'center', position: 'relative', padding: 18 }}>
					<h5 style={{ margin: 0, color: 'white' }}>{t("Select Language")}</h5>
					<FontAwesomeIcon
						icon={faTimes}
						size="lg"
						onClick={() => setShowLanguageModal(false)}
						style={{ position: 'absolute', right: 16, top: 16, cursor: 'pointer', color: 'white' }}
					/>
				</Modal.Header>
				<Modal.Body className="d-flex flex-column align-items-center p-1">
					{languages.map((lang, index) => (
						<React.Fragment key={index}>
							<div
								onClick={() => handleLanguageSelect(lang.value)}
								style={{
									display: 'flex',
									alignItems: 'center',
									width: '150px',
									padding: '18px 24px',
									cursor: 'pointer',
									textAlign: 'center'
								}}
							>
								<span role="img" aria-label={lang.label || 'en-US'} style={{ marginRight: 8, fontSize: 25 }}>
									{lang.icon || '🌐'}
								</span>
								<span style={{ fontSize: 16 }}>{lang.label}</span>
							</div>
							{index < languages.length - 1 && (
								<div style={{ width: '100%', height: 1, backgroundColor: '#eee' }} />
							)}
						</React.Fragment>
					))}
				</Modal.Body>
			</Modal>

		</div>
	);
};

export default Sidebar;
